import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'suka-topbar-navigation',
  template: `
    <nav class="topbar__nav" [attr.aria-label]="ariaLabel">
      <ul class="topbar__menu-bar" role="menubar">
        <ng-content></ng-content>
      </ul>
    </nav>
  `
})
export class TopbarNavigation {
  @Input() ariaLabel: string;
}
